import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import AdBanner from "@/components/feature/AdBanner";

export default function ContatoPage() {
  const [formData, setFormData] = useState({ name: "", email: "", subject: "", message: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-white relative">
      <Navbar />
      <div className="absolute top-0 left-0 right-0 h-48 md:h-64 bg-gradient-to-b from-alvinegro-black to-white z-0" />
      <main className="pt-20 md:pt-24 pb-12 relative z-10">
        <div className="w-full px-4 md:px-8">
          <Breadcrumb items={[{ label: "Início", path: "/" }, { label: "Contato" }]} />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            <div>
              <h1 className="font-serif font-bold text-3xl md:text-4xl text-alvinegro-black mb-4">Entre em Contato</h1>
              <p className="text-alvinegro-muted text-base mb-8">Tem alguma sugestão, dúvida ou quer colaborar com a Central Alvinegra? Fale com a gente!</p>
              <div className="space-y-6">
                {[
                  { icon: "ri-mail-line", label: "E-mail", value: "contato@centralalvinegra.com" },
                  { icon: "ri-whatsapp-line", label: "WhatsApp", value: "(21) 99999-9999" },
                  { icon: "ri-map-pin-line", label: "Endereço", value: "Rio de Janeiro, RJ - Brasil" },
                ].map((item) => (
                  <div key={item.label} className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-alvinegro-light flex items-center justify-center shrink-0">
                      <i className={`${item.icon} text-alvinegro-black`} />
                    </div>
                    <div>
                      <p className="text-sm font-medium text-alvinegro-black">{item.label}</p>
                      <p className="text-sm text-alvinegro-muted">{item.value}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8">
                <h3 className="font-semibold text-sm text-alvinegro-black mb-3">Redes Sociais</h3>
                <div className="flex items-center gap-3">
                  {["ri-whatsapp-line", "ri-facebook-circle-line", "ri-twitter-x-line", "ri-instagram-line", "ri-youtube-line", "ri-telegram-line"].map((icon) => (
                    <a key={icon} href="#" className="w-10 h-10 rounded-full bg-alvinegro-light flex items-center justify-center text-alvinegro-dark hover:bg-alvinegro-border transition-colors">
                      <i className={`${icon} text-lg`} />
                    </a>
                  ))}
                </div>
              </div>
            </div>
            <div>
              {submitted ? (
                <div className="bg-green-50 rounded-2xl p-8 text-center">
                  <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
                    <i className="ri-check-line text-3xl text-green-600" />
                  </div>
                  <h3 className="font-semibold text-lg text-alvinegro-black mb-2">Mensagem Enviada!</h3>
                  <p className="text-alvinegro-muted text-sm">Agradecemos pelo contato. Responderemos em breve.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="bg-alvinegro-light rounded-2xl p-6 md:p-8">
                  <div className="space-y-4">
                    <div>
                      <label className="text-sm font-medium text-alvinegro-black mb-1 block">Nome</label>
                      <input type="text" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required className="w-full px-4 py-3 rounded-xl border border-alvinegro-border bg-white text-sm focus:outline-none focus:border-alvinegro-black" />
                    </div>
                    <div>
                      <label className="text-sm font-medium text-alvinegro-black mb-1 block">E-mail</label>
                      <input type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} required className="w-full px-4 py-3 rounded-xl border border-alvinegro-border bg-white text-sm focus:outline-none focus:border-alvinegro-black" />
                    </div>
                    <div>
                      <label className="text-sm font-medium text-alvinegro-black mb-1 block">Assunto</label>
                      <select value={formData.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} required className="w-full px-4 py-3 rounded-xl border border-alvinegro-border bg-white text-sm focus:outline-none focus:border-alvinegro-black">
                        <option value="">Selecione um assunto</option>
                        <option value="sugestao">Sugestão</option>
                        <option value="denuncia">Denúncia de conteúdo</option>
                        <option value="parceria">Parceria</option>
                        <option value="publicidade">Publicidade</option>
                        <option value="outro">Outro</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-alvinegro-black mb-1 block">Mensagem</label>
                      <textarea value={formData.message} onChange={(e) => setFormData({ ...formData, message: e.target.value })} required rows={5} maxLength={500} className="w-full px-4 py-3 rounded-xl border border-alvinegro-border bg-white text-sm resize-none focus:outline-none focus:border-alvinegro-black" />
                      <span className="text-xs text-alvinegro-muted mt-1 block">{formData.message.length}/500</span>
                    </div>
                    <button type="submit" className="w-full bg-alvinegro-black text-white py-3 rounded-full text-sm font-medium hover:bg-alvinegro-dark transition-colors cursor-pointer whitespace-nowrap">
                      Enviar Mensagem
                      <i className="ri-send-plane-line ml-2" />
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
          <div className="mt-8">
            <AdBanner variant="leaderboard" label="Publicidade" />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}